


























import { PropType } from 'vue';
import { defineComponent, toRefs, computed } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData, CreateMode, EstimatedType } from '@tt4b/ttam-enums';
import TtamAudienceSize from './index';
import TtamAudienceSizeTipsCompose from './audience-size-tips-compose.vue';

const name = 'ttam-audience-size-compose';
export default defineComponent({
  name,
  components: {
    TtamAudienceSizeMainTitle: TtamAudienceSize.TtamAudienceSizeMainTitle,
    TtamAudienceSizeEstimateChart: TtamAudienceSize.TtamAudienceSizeEstimateChart,
    TtamAudienceSizeEstimateNum: TtamAudienceSize.TtamAudienceSizeEstimateNum,
    TtamAudienceSizeImpressionTip: TtamAudienceSize.TtamAudienceSizeImpressionTip,
    TtamAudienceSizeTipsCompose,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
  },
  setup(props) {
    const { campaignData, adgroupData, createMode } = toRefs(props);
    const { originData, data: estimateResult } = TtamAudienceSize.useDataSource({
      campaignData,
      adgroupData,
    });
    const estimateType = computed(() => estimateResult.value.score ?? EstimatedType.NONE);

    const { impressionTipVisible } = TtamAudienceSize.usePropsImpressionTipVisible({
      campaignData,
      adgroupData,
      createMode,
    });

    const { estimateFail } = TtamAudienceSize.usePropsEstimateFail({
      estimateResult,
    });
    const { ttpUnsupportedArea } = TtamAudienceSize.usePropsTtpUnsupportedArea();
    const { estimateCount } = TtamAudienceSize.usePropsEstimateCount({
      estimateResult,
    });

    const { noEstimateCount } = TtamAudienceSize.usePropsTipVisible({
      adgroupData,
      campaignData,
    });

    return {
      name,
      originData,
      estimateResult,
      estimateType,
      impressionTipVisible,
      estimateFail,
      ttpUnsupportedArea,
      estimateCount,
      noEstimateCount,
    };
  },
});
